// extracted by mini-css-extract-plugin
export default {"separator":"tP2I3SjLYAnTxVFVbw95pw=="};